import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { CiLogsSection } from "../features/connections/CiLogsSection";
import { CoderSystemSection } from "../features/connections/CoderSystemSection";
import { ForgejoSection } from "../features/connections/ForgejoSection";
import { TaskTrackerSection } from "../features/connections/TaskTrackerSection";
import { useEnabledModules } from "../features/modules/useEnabledModules";

// Страница `/settings/connections`.
//
// Forgejo-секция (репо-хост), трекер задач (ADR-0075, отдельное
// подключение — даже на том же сервере), CI-логи и coder-система (R55)
// вынесены в `features/connections/` — эта страница тонкий контейнер,
// который компонует секции включённых модулей под общим заголовком:
// `repo_host`, `task_tracker`, `ci_log`, `provider`. Страница смонтирована под
// `RequireModule`, поэтому состав здесь уже загружен.
export function SettingsConnectionsPage(): ReactElement {
  const { t } = useTranslation();
  const modules = useEnabledModules();

  return (
    <Container py="xl">
      <Stack gap="md">
        <Title order={1}>{t("connections.title")}</Title>
        {modules.isEnabled("repo_host") ? <ForgejoSection /> : null}
        {modules.isEnabled("task_tracker") ? <TaskTrackerSection /> : null}
        {modules.isEnabled("ci_log") ? <CiLogsSection /> : null}
        {modules.isEnabled("provider") ? <CoderSystemSection /> : null}
      </Stack>
    </Container>
  );
}
